import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import './DarkModeToggle.css';

interface DarkModeToggleProps {
  className?: string;
  style?: React.CSSProperties;
  fontSize?: string | number;
}

const DarkModeToggle: React.FC<DarkModeToggleProps> = ({
  className = '',
  style = {},
  fontSize,
}) => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <label
      className={`switch ${className}`}
      style={{ ...(fontSize ? { fontSize } : {}), ...style }}
      title={isDark ? 'Cambiar a modo día' : 'Cambiar a modo noche'}
      aria-label="Alternar modo noche y día"
    >
      <input
        type="checkbox"
        checked={isDark}
        onChange={toggleTheme}
        aria-checked={isDark}
      />
      <div className="slider">
        <div className="circle">
          <div className="moon" />
          <span className="shine shine-1" />
          <span className="shine shine-2" />
          <span className="shine shine-3" />
          <span className="shine shine-4" />
          <span className="shine shine-5" />
          <span className="shine shine-6" />
          <span className="shine shine-7" />
          <span className="shine shine-8" />
        </div>
      </div>
    </label>
  );
};

export default DarkModeToggle;
